<template>
	<div class="layerPop" id="PopNoti" v-if="isVisible">
		<div class="popWrap">
			<div class="popBox popType2">
				<div class="popHead">
					<p class="popTit">{{state.title}}</p>
				</div>

				<div class="popCon">
					<div class="memoView lh28 hAuto" v-html="state.contents">
					
					</div>
				</div>
				<button type="button" class="popClose" @click="close(this);"><span class="hide">닫기</span></button>
			</div>
		</div>
	</div>	
</template>

<script setup>
import {ref , reactive, defineEmits,defineExpose} from 'vue'

const isVisible = ref(false);

const emits = defineEmits(['update:data' ,'close']);

const close = () => {
	isVisible.value = false;
	emits('close');
}

const open = async (object) => {
    isVisible.value = true;
	state.title = object.SUBJECT;
	state.contents = object.CONTENT;
}
const state = reactive({
	title : '',
	contents : '',
});

defineExpose({open , close})


</script>